/**
 * Points the store-free app-store port (`lib/appStore/appStorePort`) at the
 * real Zustand store. Imported first by `main.tsx` (so it runs before any
 * module that may call `loadAppStore()`) and by the Vitest setup (so tests
 * that `vi.mock` the store keep receiving their mock). Runtimes that never
 * import this module — the Cloud Run workers, the Express server, scripts —
 * use the headless store instead.
 *
 * Each module is still loaded lazily and separately, exactly as the former
 * `await import('../store')` / `import('../store/authMissingProviderToast')`
 * call sites did.
 */
import { installAppRuntimeLoader, type AppRuntimeLoader } from '../lib/appStore/appStorePort';

export const browserAppRuntimeLoader: AppRuntimeLoader = {
  loadStore: async () => (await import('./index')).useStore,
  loadAuthMissingProviderNotifier: async () =>
    (await import('./authMissingProviderToast')).maybeToastAuthMissingProviders,
};

installAppRuntimeLoader(browserAppRuntimeLoader);
